// hooks/useSimpleEmail.js
import { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

export const useSimpleEmail = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const functions = getFunctions();

    const sendEmail = async (to, subject, message, customHtml = null) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const sendEmailFunction = httpsCallable(functions, 'sendEmail');

            // HTML por defecto si no se proporciona uno personalizado
            const defaultHtml = `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h2 style="color: #333;">Miguel App</h2>
          <div style="background-color: #f9f9f9; padding: 20px; border-radius: 8px; margin: 20px 0;">
            ${message.replace(/\n/g, '<br>')}
          </div>
          <hr style="margin: 20px 0; border: none; border-top: 1px solid #ddd;">
          <p style="font-size: 12px; color: #666; text-align: center;">
            Enviado desde Miguel App
          </p>
        </div>
      `;

            const result = await sendEmailFunction({
                to,
                subject,
                message,
                html: customHtml || defaultHtml
            });

            setSuccess(true);
            return result.data;

        } catch (err) {
            const errorMessage = err.message || 'Error enviando email';
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const sendBulkEmail = async (recipients, subject, message, customHtml = null) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const sendBulkEmailFunction = httpsCallable(functions, 'sendBulkEmail');

            const defaultHtml = `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <h2 style="color: #333;">Miguel App</h2>
          <div style="background-color: #f9f9f9; padding: 20px; border-radius: 8px; margin: 20px 0;">
            ${message.replace(/\n/g, '<br>')}
          </div>
          <hr style="margin: 20px 0; border: none; border-top: 1px solid #ddd;">
          <p style="font-size: 12px; color: #666; text-align: center;">
            Enviado desde Miguel App
          </p>
        </div>
      `;

            const result = await sendBulkEmailFunction({
                recipients: Array.isArray(recipients) ? recipients : [recipients],
                subject,
                message,
                html: customHtml || defaultHtml
            });

            setSuccess(true);
            return result.data;

        } catch (err) {
            const errorMessage = err.message || 'Error enviando emails';
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const resetState = () => {
        setLoading(false);
        setError(null);
        setSuccess(false);
    };

    return {
        sendEmail,
        sendBulkEmail,
        loading,
        error,
        success,
        resetState
    };
};

export default useSimpleEmail;